import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trackFeatureUsage } from '@animoto/utils/analytics';
import {
  Button,
  BodySmall,
  HeaderExtraSmall,
  TitleMedium,
  TitleSmall,
  HeaderSmall
} from '@animoto/components/lib/es/design-system';

import './VideoSteps.module.css';

const videoStepsCopy = [
  {
    title : 'Add photos and video clips',
    body  : 'Select a template or start from scratch. Then drag and drop photos and video clips right into your project.'
  },
  {
    title : 'Personalize your video',
    body  : 'Quickly adjust colors, fonts, music, and more to customize your video. Match your own style or brand with ease.'
  },
  {
    title : 'Share and impress',
    body  : 'Produce and share your video in moments. Wow friends and family or boost business sales and engagement.'
  }
];

export default function VideoSteps({
  isMobile,
  isIOS,
  onClick
}) {
  const trackClick = () => {
    trackFeatureUsage({
      scope   : 'visitor-play-page',
      feature : 'video-in-steps',
      action  : 'click'
    });
  };
  const onClickButton = () => {
    trackClick();
    onClick();
  };
  const getDesktopBody = () => (
    <>
      <TitleMedium styleName="title">Make a video in 3 easy steps</TitleMedium>
      <div styleName="steps-container">
        { videoStepsCopy.map(({ title, body }, i) => (
          <div key={title} styleName="steps">
            <div styleName={`number-${i + 1} number`} />
            <HeaderSmall styleName="header">{title}</HeaderSmall>
            <BodySmall>{body}</BodySmall>
          </div>
        ))}
      </div>
    </>
  );
  const getMobileBody = () => (
    <>
      <TitleSmall styleName="title">Make a video in 3 easy steps</TitleSmall>
      <div styleName="steps-container">
        { videoStepsCopy.map(({ title }, i) => (
          <div key={title} styleName="steps">
            <div styleName={`number-${i + 1} number`} />
            <HeaderExtraSmall styleName="header">{title}</HeaderExtraSmall>
          </div>
        ))}
      </div>
    </>
  );

  const containerClasses = classNames('container', {
    'is-desktop' : !isMobile
  });

  return (
    <>
      <div styleName="divider" />
      <div styleName={containerClasses}>
        {!isMobile ? (
          getDesktopBody()
        ) : (
          getMobileBody()
        )}
        <Button
          href={isIOS ? '/builder-mobile' : '#'}
          onClick={isIOS ? trackClick : onClickButton}
          styleName="button"
        >
          Make a video
        </Button>
      </div>
    </>
  );
}

VideoSteps.propTypes = {
  isIOS    : PropTypes.bool.isRequired,
  isMobile : PropTypes.bool.isRequired,
  onClick  : PropTypes.func.isRequired
};
